export function suggestedSiteName(filename) {
  const name = String(filename || '').split(/[/\\]/).pop().replace(/\.html?$/i, '')
    .normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
    .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 40).replace(/-$/, '');
  return !siteNameError(name) && !['index', 'main', 'app', 'preview'].includes(name) ? name : 'my-creation';
}

// Read a title as text; never evaluate generated HTML to name its saved file.
export function suggestedHtmlFilename(html) {
  const title = String(html || '').replace(/<!--[\s\S]*?-->/g, '')
    .match(/<title\b[^>]*>([^<]*)<\/title\s*>/i)?.[1] || '';
  const text = title.replace(/&(?:#\d+|#x[0-9a-f]+|[a-z]+);/gi, ' ').replace(/[/\\]/g, ' ');
  return `${suggestedSiteName(text)}.html`;
}

export function siteNameError(name) {
  if (name.length < 3 || name.length > 40) return 'Choose a name with 3–40 characters.';
  if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name) || !/[a-z]/.test(name)) {
    return 'Use letters, numbers, and single hyphens. Include at least one letter.';
  }
  if (name.startsWith('xn-')) return 'Names can’t start with “xn-”.';
  return null;
}
